import PropTypes from 'prop-types';

import css from './label.module.scss';

const Label = ({ labelText, dataTestId, isRequired, style = {} }) => (
  <div className={css.labelContainer}>
    <label className={css.label} style={style} data-testid={dataTestId}>
      {isRequired ? `${labelText} *` : labelText}
    </label>
  </div>
);

Label.propTypes = {
  labelText: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  style: PropTypes.object,
  isRequired: PropTypes.bool,
};

export default Label;
